import type { PhoneVerdict } from '~/enums/PhoneVerdict'
import type { PhoneIssueVerdict } from '~/types/PhoneIssueVerdict'

/** Names the outcome of a `PhoneNumber` verdict lookup, which has no verdict for an issue that is not a phone rule. */
export function phoneIssueVerdict(lookup: PhoneVerdict | undefined): PhoneIssueVerdict {
  return lookup === undefined ? { isPhoneIssue: false } : { isPhoneIssue: true, verdict: lookup }
}
